import { Avatar } from 'evergreen-ui';
import { styled } from 'linaria/react';
import React from 'react';
import { useStore } from 'effector-react';

import { User } from 'src/domain/user';
import { group$ } from 'src/store/group.store';
import { Tag } from 'src/ui/atoms/tag';

const Header = styled.div`
	display: flex;
	margin-bottom: 64px;
`;
const Name = styled.div`
	font-size: 23px;
	color: var(--blue500);
`;
const Email = styled.div`
	font-size: 14px;
	color: var(--gray500);
`;
const InfoItem = styled.div`
	align-items: center;
	margin: 10px 0;
	font-size: 14px;
    padding: 20px 15px;
    background: #e8f0fe;
	
	strong {
		font-weight: 500;
		margin-right: 10px;
	}
`;

export const MemberSlavePage = () => {
	const group = useStore(group$);
	const slave = group?.joined_user?.slave as User;

	if (!slave) { return <></>; }

	const slaveFullName = [
		slave.details.first_name,
		slave.details.last_name,
	].join(' ');

	const fields = [{
		title: 'Country',
		value: slave.details.country,
	}, {
		title: 'City',
		value: slave.details.city,
	}, {
		title: 'Region',
		value: slave.details.state,
	}, {
		title: 'Address',
		value: slave.details.address,
	}, {
		title: 'Zip / Postal code',
		value: slave.details.postal_code,
	}]
		.filter(item => Boolean(item.value));

	return (
		<>
			<Header>
				<Avatar
					size={80}
					name={slaveFullName}
					src={slave.details.avatar || undefined}
				/>
				<div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
					<Name>{slaveFullName}</Name>
				</div>
			</Header>
			<InfoItem>
				<strong>Date of birth:</strong> {slave.details.dob}
			</InfoItem>
			<InfoItem>
				<strong>Phone:</strong> {slave.details.phone}
			</InfoItem>
			<InfoItem>
				<strong>Sex:</strong> {slave.details.sex === 'f' ? 'Female' : 'Male'}
			</InfoItem>
			<InfoItem>
				<strong>Interests:</strong> {slave.interests.map(item => <Tag>{item.name}</Tag>)}
			</InfoItem>
			{fields.map(item => (
				<InfoItem>
					<strong>{item.title}:</strong> {item.value}
				</InfoItem>
			))}
		</>
	);
};
